/* Tipo de fluxo do lead -- define campos, checklist de documentos e o
   modelo de contrato. Lead sem fluxo é anterior a isso: "Legado". */
export const FLUXOS = [
  { id: 'abertura',      label: 'Cliente novo – Abertura de empresa',                 curto: 'Abertura',      pontual: 'Valor da abertura' },
  { id: 'transferencia', label: 'Cliente novo – Transferência de escritório',         curto: 'Transferência', pontual: 'Valor da transferência' },
  { id: 'revisao',       label: 'Cliente ativo – Revisão/reorganização cadastral',    curto: 'Revisão',       pontual: 'Valor da revisão (se houver)' },
  { id: 'alteracao',     label: 'Cliente novo ou ativo – Alteração contratual/cadastral', curto: 'Alteração', pontual: 'Valor da alteração' },
  { id: 'baixa',         label: 'Baixa de empresa',                                   curto: 'Baixa',         pontual: 'Valor da baixa' },
];

export const fluxoPorId = (id) => FLUXOS.find(f => f.id === id) || null;
export const nomeCurtoFluxo = (id) => fluxoPorId(id)?.curto || 'Legado';

export const FORMAS_PAGAMENTO = ['Boleto', 'PIX', 'Transferência bancária', 'Débito automático', 'Cartão de crédito'];
export const ESTADOS_CIVIS = ['Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 'Viúvo(a)', 'União estável', 'Separado(a)'];
